<template>
  <div>
    <div class="tips">
      您访问的页面不存在,请修改后重试，或
      <router-link replace to="/">前往首页</router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.tips {
  font-size: 20px;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
